import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import * as routes from './routes'
import Icon from 'react-icons-kit'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'

import './Success.css'

class Success extends Component {
    render() {
        return (
            <div className='success_container card'>
                <Icon size={50} icon={ic_check_circle} className='status_complete' />
                <h1>Success!</h1>
                <h4>Payment Received.</h4>
                <br/>
                <p>Your account has been upgraded to Premium.</p>
                <p>Note: it may take up to 1-2 minutes to gain full access to all premium videos.</p>
                <p>If you have any issues please contact <a href="mailto:admin@candidgirls.io">admin@candidgirls.io</a></p>
                <p>Admin can be reached on forum here: <a href="https://forum.candidgirls.io/u/Taylor_Swift">Owner</a></p>
                <br/>
                <Link to={routes.HOME}>
                    <button className='custom_btn'>Take me to the videos</button>
                </Link>
            </div>
        )
    }
}

export default Success
